import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CheckboxList } from '../../../../../common-client2/src/components';
import './FilterWithHeaderSection.scss';

function FilterWithHeaderSection({
    title,
    items = [],
    onChange = () => { },
    expandIcon = (<ExpandMoreIcon className="expand-more-icon" />),
}) {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'filterPanel' });
    const [accordionExpanded, setAccordionExpanded] = useState(false);
    const [isSelectedAllChecked, setIsSelectedAllChecked] = useState(true);
    const [isTransferIncluded, setIsTransferIncluded] = useState(true);
    const mappedItems = items.map((item) => ({ ...item, checked: true }));
    const [selections, setSelections] = useState(mappedItems);

    const isAllSelectionChecked = selections.every((selection) => selection.checked);
    const isAllSelectionUnchecked = selections.every((selection) => !selection.checked);

    useEffect(() => {
        if (items.length !== selections.length) {
            const mappedItems = items.map((item) => ({ ...item, checked: item.checked ?? true }));
            setSelections(mappedItems);
        }
    }, [items]);

    const handleToggleCheckAll = () => {
        const newValue = !isSelectedAllChecked;
        setIsSelectedAllChecked(newValue);
        const updatedSelections = selections.map((selection) => ({ ...selection, checked: newValue }));
        setSelections(updatedSelections);
        onChange({ selectedItems: updatedSelections, isTransferIncluded });
    };

    const handleToggleIncludeTransfer = () => {
        const newValue = !isTransferIncluded;
        setIsTransferIncluded(newValue);
        onChange({ selectedItems: selections, isTransferIncluded: newValue });
    };

    const handleToggleCheckItem = (newItems) => {
        setSelections(newItems);
        onChange({ selectedItems: newItems, isTransferIncluded });
    };

    return (
        <Accordion
            className="filter-with-header-section"
            expanded={accordionExpanded}
            onChange={() => setAccordionExpanded(!accordionExpanded)}
        >
            <AccordionSummary expandIcon={expandIcon}>
                <Typography className="filter-section-title">
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div className="filter-section-header">

                    <FormControlLabel
                        className="filter-check-all-label"
                        label={t('selectAllLabel')}
                        control={(
                            <Checkbox
                                className="check-all-checkbox"
                                color="primary"
                                checked={isAllSelectionChecked}
                                indeterminate={!isAllSelectionChecked && !isAllSelectionUnchecked}
                                onChange={(event) => handleToggleCheckAll(event.target.checked)}
                            />
                        )}
                    />
                    <FormControlLabel
                        className="filter-include-transfer-label"
                        label={'Include transfers'}
                        control={(
                            <Checkbox
                                className="include-transfer-checkbox"
                                color="primary"
                                checked={isTransferIncluded}
                                onChange={(event) => handleToggleIncludeTransfer(event.target.checked)}
                            />
                        )}
                    />
                </div>
                <hr className="filter-section-seperator" />
                {
                    <CheckboxList
                        useNumericTotals
                        items={selections}
                        onChange={(
                            /** @type {import("@commonClient2/components/CheckboxList/typing").CheckboxListItem[]} */
                            newItems,
                            /** @type {import("@commonClient2/components/CheckboxList/typing").CheckboxListItem} */
                            changedItem,
                        ) => { handleToggleCheckItem(newItems); }}
                    />
                }
            </AccordionDetails>
        </Accordion>
    );
}

export default FilterWithHeaderSection;